import { Navigate } from 'react-router-dom';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';

const ApprovalsApp = lazyRetry(() => import('./ApprovalsApp'));
const ApprovalsList = lazyRetry(() => import('./ApprovalsList'));
const ApprovalDetail = lazyRetry(() => import('./ApprovalDetail'));
const EmailLanding = lazyRetry(() => import('./EmailLanding'));

const ApprovalsAppConfig: FuseRouteItemType = {
    path: 'approvals',
    element: <ApprovalsApp />,
    children: [
        { path: '', element: <ApprovalsList /> },
        { path: 'email/:token', element: <EmailLanding /> },
        { path: ':id', element: <ApprovalDetail /> }
    ]
};

export default ApprovalsAppConfig;
